<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<div class="container">
  <div class="px-4 pt-5 my-5 text-center">
    <h1 class="display-4 fw-bold">{text(block, 'headline')}</h1>
    <div class="col-lg-6 mx-auto">
      <p class="lead mb-4">{@html richtext(block, 'main')}</p>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">

        {#if exists(block, 'buttonPrimary')}
        <a class="btn btn-primary btn-lg px-4 me-sm-3" href="{url(block, 'buttonPrimary')}" use:link>
          {text(block, 'buttonPrimary')}
        </a>
        {/if}

        {#if exists(block, 'buttonSecondary')}
        <a class="btn btn-outline-secondary btn-lg px-4" href="{url(block, 'buttonSecondary')}" use:link>
          {text(block, 'buttonSecondary')}
        </a>
        {/if}

      </div>
    </div>
  </div>
</div>
